import { render, staticRenderFns } from "./sbrr_one_breaches_2900_threshold.vue?vue&type=template&id=aafe4652"
import script from "./sbrr_one_breaches_2900_threshold.vue?vue&type=script&lang=js"
export * from "./sbrr_one_breaches_2900_threshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports